export class TechModalDialogResendModel {
  title?: String;
  icon?: String;
  content?: String;
  btoaccept?: String;
  note?: String;
}
